import React from 'react';
import EnhancedHeroSection from './EnhancedHeroSection';
import ServiceSections from './ServiceSections';

const MainComponent = () => (
  <>
    <EnhancedHeroSection />
    <ServiceSections />
  </>
);

export default MainComponent;